<div id="folderSelectorModal">
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      mat-icon-button
      id="closeButton"
      class="close"
      (click)="dismiss()"
      data-dismiss="modal"
      aria-label="Click to close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 id="title" class="tw-text-center">Select Destination</h4>
  <mat-dialog-content class="storage-full">
    <files-list
      [folderPath]="folderPath"
      [isListView]="true"
      [allowUpload]="false"
      [allowBatchOperations]="false"
      [excludedFiles]="excludedFiles"
      (filesSelected)="close($event)"
      [selectorType]="StorageUtilsService.SELECTOR_TYPES.SINGLE_FOLDER"
      [selectorFilter]="StorageUtilsService.SELECTOR_FILTERS.FOLDERS"
      [storageFull]="false"
    >
    </files-list>
  </mat-dialog-content>

  <mat-dialog-actions
    class="tw-flex tw-justify-end tw-flex-col md:!tw-flex-row tw-gap-2.5"
  >
    <button
      rv-button
      variant="secondary"
      id="folderSelectorCancelButton"
      type="button"
      class="tw-w-full md:!tw-w-fit"
      (click)="dismiss()"
    >
      Cancel
    </button>
    <button
      rv-button
      variant="secondary"
      id="newFolderButton"
      type="button"
      class="tw-w-full md:!tw-w-fit"
      (click)="filesList.createFolder()"
      [disabled]="isTrashFolder"
    >
      <mat-icon svgIcon="add-folder-2" aria-hidden="true" />
      New Folder
    </button>
    <button
      rv-button
      id="folderSelectorSaveButton"
      type="submit"
      class="tw-w-full md:!tw-w-fit"
      (click)="filesList.sendFiles()"
    >
      {{
        filesList?.selectedFolders.length || filesList?.selectedFiles.length
          ? 'Move'
          : 'Move here'
      }}
    </button>
  </mat-dialog-actions>
</div>
